import { useState } from "react";
import { Sparkles, TrendingUp, Rocket, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtUsd } from "@/lib/api";
import { cn } from "@/lib/utils";

const RISK = [
  { key: "low", label: "Düşük", color: "#00FFA3" },
  { key: "medium", label: "Orta", color: "#A374FF" },
  { key: "high", label: "Yüksek", color: "#FF3366" },
];

export const OpportunityCorner = ({ opportunities, onLaunch }) => {
  const [risk, setRisk] = useState("medium");
  const [launching, setLaunching] = useState(null);

  const launch = async (sym) => {
    setLaunching(sym);
    try { await onLaunch(sym, risk); }
    finally { setLaunching(null); }
  };

  return (
    <div data-testid="opportunity-corner" className="rounded-lg border border-[#A374FF]/25 bg-[var(--app-bg)]">
      <div className="flex items-center gap-2.5 px-5 h-14 border-b border-[var(--border)]">
        <div className="h-8 w-8 rounded-md bg-[#A374FF]/15 border border-[#A374FF]/30 flex items-center justify-center">
          <Sparkles className="h-4 w-4 text-[var(--accent)]" />
        </div>
        <h3 className="font-head font-bold text-base">Fırsat Köşesi</h3>
        <span className="ml-auto text-[10px] text-[var(--accent)] tracking-widest">AI ÖNERİLERİ</span>
      </div>

      <div className="px-5 py-3 border-b border-[var(--surface-hover)] flex items-center gap-2">
        <span className="text-[11px] text-[var(--text-faint)] uppercase tracking-wider">Bot Riski:</span>
        {RISK.map((r) => (
          <button key={r.key} data-testid={`opp-risk-${r.key}`} onClick={() => setRisk(r.key)}
            className={cn("px-2.5 h-7 rounded-full border text-[11px] font-mono transition-all",
              risk === r.key ? "text-black font-bold" : "border-[var(--border)] text-[var(--text-dim)] hover:text-[var(--text-primary)]")}
            style={risk === r.key ? { background: r.color, borderColor: r.color } : {}}>
            {r.label}
          </button>
        ))}
      </div>

      <div className="p-4 space-y-3 max-h-[520px] overflow-y-auto">
        {(!opportunities || opportunities.length === 0) && (
          <div className="text-center py-10 text-[var(--text-faint)]">
            <Rocket className="h-8 w-8 mx-auto mb-3 opacity-40" />
            <p className="text-sm">Şu an öne çıkan fırsat yok.</p>
            <p className="text-xs mt-1">"Piyasayı Analiz Et" ile fırsatları üretin.</p>
          </div>
        )}
        {(opportunities || []).map((o) => {
          const up = o.current_price && o.entry_price ? o.current_price >= o.entry_price : true;
          return (
            <div key={o.symbol} data-testid={`opportunity-${o.symbol}`}
              className="rounded-lg border border-[var(--border)] bg-[var(--surface)] p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="font-head font-bold text-base">{o.symbol}</span>
                  <span className="flex items-center gap-1 text-[11px] text-[var(--pos)]">
                    <TrendingUp className="h-3.5 w-3.5" /> yükseliş potansiyeli
                  </span>
                </div>
                <div className="text-right">
                  <div className="text-[10px] text-[var(--text-faint)] uppercase">Güven</div>
                  <div className="font-mono font-bold text-[var(--accent)]">{o.confidence}%</div>
                </div>
              </div>
              <div className="text-[11px] text-[var(--text-faint)] font-mono mb-2">Fiyat: {fmtUsd(o.current_price)}</div>
              <p className="text-[13px] leading-relaxed text-[var(--text-dim)] mb-3 border-l-2 border-[#A374FF]/40 pl-3">
                {o.reasoning}
              </p>
              <Button data-testid={`launch-bot-${o.symbol}`} onClick={() => launch(o.symbol)} disabled={launching === o.symbol}
                className="w-full h-10 bg-[var(--accent)] text-black font-bold hover:bg-[#b48fff] hover:text-black">
                {launching === o.symbol ? <Loader2 className="h-4 w-4 animate-spin" />
                  : <><Rocket className="h-4 w-4 mr-1.5" /> Botu Bu Coin İçin Başlat</>}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
